import {
  METRIC_THREAD_GUIDE_SECTIONS,
  METRIC_THREAD_STANDARDS,
} from '../../shared/metricThreadSeo.mjs';

const MetricThreadSeoContent = () => (
  <section className="metricThreadGuide" aria-labelledby="metric-thread-guide-title">
    <header>
      <p>Practical reference</p>
      <h2 id="metric-thread-guide-title">ISO metric thread fundamentals</h2>
      <span>Use these definitions to interpret the calculator output and distinguish reference geometry from manufacturing limits.</span>
    </header>

    <div className="metricThreadGuideGrid">
      {METRIC_THREAD_GUIDE_SECTIONS.map(section => (
        <section key={section.title}>
          <h3>{section.title}</h3>
          {section.paragraphs.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
        </section>
      ))}
    </div>

    <section className="metricThreadStandards" aria-labelledby="metric-thread-standards-title">
      <h3 id="metric-thread-standards-title">Technical references</h3>
      <p>The calculator uses published ISO metric-thread concepts without reproducing copyrighted standards tables or normative text.</p>
      <ul>
        {METRIC_THREAD_STANDARDS.map(standard => (
          <li key={standard.name}>
            <a href={standard.url}>{standard.name}</a> — {standard.description}
          </li>
        ))}
      </ul>
    </section>
  </section>
);

export default MetricThreadSeoContent;
